export var reduxKey = '@@BI';
export var actionKey = '@@BI';
//# sourceMappingURL=constants.js.map